const firebaseConfig = {
  apiKey: 'AIzaSyB8a-XklNVY5S--8SCiAEIsJ_zf0idXthQ',
  authDomain: 'dragons-react.firebaseapp.com',
  projectId: 'dragons-react',
  storageBucket: 'dragons-react.appspot.com',
  messagingSenderId: '123636410023',
  appId: '1:123636410023:web:493093c1b85eb304559d82',
};

export default firebaseConfig;
